import React, { useState } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';

import Operation from '../../component/utility/setting/Operation';
import Compliance from '../../component/utility/setting/Compliance';
import Planning from '../../component/utility/setting/Planning';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
//


const Organisation = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };    

    return (
        <>
            <Header />
            <Page title='Organisation' breadcrumbs='Home / Organisation'>

            <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="Operation" {...a11yProps(0)} />
                            <Tab label="Compliance" {...a11yProps(1)} />
                            <Tab label="Planning" {...a11yProps(2)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        <Operation />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Compliance /> 
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <Planning />
                    </TabPanel>
                </Box>

            </Page>
            <Footer />
        </>
    )
}

export default Organisation;